// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"90ba4ddd","383":"e2503a93","488":"7b715899"}[chunkId] + ".chunk.css";
};